module.exports = __webpack_public_path__ + "static/media/04.f364d1e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dayup/home/04.png
// module id = 797
// module chunks = 0